import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=e96dbe5c"
import script from "./AppSettings.vue?vue&type=script&lang=ts"
export * from "./AppSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports